import './assets/js/newPricing.js';
import { htmlPrefilter } from 'jquery';
import $ from 'jquery';
import './assets/js/vendors/flexibility.js';
import './assets/js/vendors/jquery.easy-autocomplete.min.js';
import './assets/js/vendors/prism.js';
import './assets/js/vendors/utils.js';
import './assets/js/roi.js';
import './assets/js/main.js';
import './assets/js/newForm.js';
import './assets/js/forms.js';
import './assets/js/moment-custom.js';
import './assets/js/quotes-home.js';
import './assets/js/clients-carousel-home.js';
import './assets/js/contact-carousel.js';
import './assets/js/origin.js';
import './assets/js/home.js';
import './assets/js/components/navBarHome.js';
import './assets/js/components/allFunctionallities.js';
import './assets/js/components/tabs.js';
import './assets/js/components/pricingLayout.js';
import './assets/js/components/subMenuFeatures.js';
import './assets/js/pricingSelector.js';





require('./assets/js/fromdoppler.font.js');
import './assets/styles/styles.scss';
